import { Editor, Extensions } from "@tiptap/vue-2"
import StarterKit from "@tiptap/starter-kit"
import Highlight from "@tiptap/extension-highlight"
import { Placeholder } from "@tiptap/extension-placeholder"
import { SmilieReplacer } from "components/Wysiwyg/extensions/SmilieReplacer"
import ComponentRenderProxy, { Ref, ref } from "vue"
import { Link } from "@tiptap/extension-link"
import {
  ConfiguredSuusMentionExtension,
  SuggestionFunction,
} from "components/Wysiwyg/extensions/suus-mention/suus-mention.config"

export function useBasicExtensions(
  parentComponent: ComponentRenderProxy,
  suggestionFunction: SuggestionFunction = (_) => []
): Extensions {
  return [
    ConfiguredSuusMentionExtension(suggestionFunction, parentComponent),
    Link, // a-Tags from mention has higher precedence!
  ]
}

export function useCoreWysiwyg(
  value: Ref<string> = ref(""),
  placeholder = "",
  css_classes = "suus__editor__wysiwyg",
  editorExtensions: Extensions = [],
  disabled?: boolean
) {
  const editor = new Editor({
    editorProps: {
      attributes: { class: css_classes },
    },
    editable: !disabled,
    extensions: [
      StarterKit,
      Highlight,
      SmilieReplacer,
      Placeholder.configure({
        placeholder: placeholder,
        emptyNodeClass: "is-editor-empty",
      }),
      ...(editorExtensions ?? []),
    ],
    content: value.value,
    onUpdate: () => {
      value.value = editor.getHTML()
    },
  })

  return editor
}
